class PopUpController {

    constructor() {

        this._$popUpContainer = null;
        this._$popUp = null;

        this._animationSpeed = 500;

    }

    getAnimationSpeed() {
        return this._animationSpeed;
    }

    setAnimationSpeed() {
        return this._animationSpeed;
    }

    setPopUp(template, context) {

        this._$popUpContainer = $("#popupContainer");
        this._$popUpContainer.html(template(context));
        this._$popUp = $("div.bf-popup");

    }

    showPopUp(displayPosition) {

        this._$popUpContainer.modal("show");

        const windowHeight = $(window).height();
        const popUpHeight = this._$popUp.height();
        const popUpMaxHeight = parseInt(this._$popUp.css("max-height"));
        const that = this;

        if (displayPosition === "center") {
            this._$popUp.addClass("is-display-center");
        }

        // El pop up solo se colocará abajo si cabe en pantalla si no lo centrará para que reparta el espacio entre arriba y abajo.
        if (displayPosition === "bottom") {

            this._$popUp.addClass(function(index, displayPosition) {
                const popUpFitOnScreen = popUpHeight < Math.floor((windowHeight * popUpMaxHeight) / 100);
                return popUpFitOnScreen ? "is-display-bottom" : "is-display-center";
            });

        }

        // Añadir la clase de forma asincrona
        setTimeout(function() {
            that._$popUp.addClass("is-visible");
        }, 0);

    }

    hidePopUp() {

        function _onTransitionComplete() {
            that._$popUpContainer.modal("hide").empty();
        }

        const that = this;

        this._$popUp.removeClass("is-visible");
        setTimeout(_onTransitionComplete, this._animationSpeed);

    }

}